import { Text } from '@/components/Text/Text'
import { Box, type BoxProps } from '@/components/Box/Box'
import css from './text.module.css'
import cn from 'clsx'
import type { DetailedHTMLProps, HTMLAttributes } from 'react'

export function Strong({ children }: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <Text tag="strong" size="inherit" weight="semibold">
            {children}
        </Text>
    )
}

export function Pre({ children, ...rest }: BoxProps) {
    return (
        <Box tag="pre" className={css.pre} {...rest}>
            {children}
        </Box>
    )
}

export function Italic({
    children,
    ...rest
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <Text tag="i" size="inherit" style={{ fontStyle: 'italic' }} {...rest}>
            {children}
        </Text>
    )
}

export function Em({
    children,
    className,
    ...rest
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <em className={cn(css.em, className)} {...rest}>
            {children}
        </em>
    )
}

export function Code({
    children,
    className,
    ...rest
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <code className={cn(css.code, className)} {...rest}>
            {children}
        </code>
    )
}
